export default __webpack_public_path__ + "static/media/cotality-emap-logo.8961bfb4.svg";